import { addToGlobalThisRet } from "@plugins";

const tooltipOptions = {
    placement: "top",
    arrow: false,
};

function collapseEvents() {
    const eventWraps = document.querySelectorAll(".js-events-collapse-init");

    if (eventWraps) {
        eventWraps.forEach((eventList) => {
            if (Array.from(eventList.children).length > 2) {
                eventList.classList.add("collapsed");

                const events = [];
                Array.from(eventList.children).forEach((event) => {
                    const eventTitle = event.querySelector(".events-calendar__event-title");
                    const eventTime = event.querySelector(".events-calendar__event-time");
                    const eventStatus = event.classList.contains("ended") ? "ended" : "";
                    const eventItem = `
                        <div class="tooltip__events-item ${eventStatus}">
                            <a href="${eventTitle.href}" class="tooltip__events-title">${eventTitle.textContent}</a>
                            <div class="tooltip__events-time">${eventTime.textContent}</div>
                        </div>
                    `;
                    events.push(eventItem);
                });

                eventList.insertAdjacentHTML(
                    "beforeend",
                    `<div class="events-calendar__tooltip-trigger js-events-calendar-tooltip-init" data-tooltip-target>
                        +Ещё ${Array.from(eventList.children).length - 2}
                        <div class="tooltip" data-tooltip-content>
                            <div class="tooltip__content">
                                <div class="tooltip__events-list">
                                    ${events.join(" ")}
                                </div>
                            </div>
                        </div>
                    </div>`,
                );
            }
        });
    }

    globalThis.ret.initContentTooltips(".js-events-calendar-tooltip-init", tooltipOptions);
}

window.addEventListener("load", () => {
    collapseEvents();
});

addToGlobalThisRet(collapseEvents, "collapseEvents");
